type EmailPayload = {
  subject: string
  htmlContent: string
}

type ContactFormInput = {
  fullName: string
  email: string
  topic: string
  content: string
}

export function buildContactFormEmail(input: ContactFormInput): EmailPayload {
  return {
    subject: `Formularz kontaktowy: ${input.topic}`,
    htmlContent: `
      <html>
        <head>
          <meta charset="UTF-8">
          <title>${input.topic}</title>
        </head>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
          <p><strong>Nadawca:</strong> ${input.fullName}</p>
          <p><strong>Email:</strong> ${input.email}</p>

          <h3 style="color: #374151; margin-top: 20px;">Treść wiadomości:</h3>
          <div style="background-color: #f9fafb; padding: 15px; border-left: 4px solid #2563eb; margin: 10px 0;">
            ${input.content.replaceAll('\n', '<br>')}
          </div>
        </body>
      </html>
    `
  }
}

export function buildNewsletterSignupEmail(email: string): EmailPayload {
  return {
    subject: 'Zapis do newslettera',
    htmlContent: `Użytkownik o emailu ${email} zapisał się do newslettera.`
  }
}

type CourseOpeningReminderInput = {
  email: string
  courseCategory?: string
}

export function buildCourseOpeningReminderEmail(input: CourseOpeningReminderInput): EmailPayload {
  const { email, courseCategory } = input

  if (courseCategory) {
    return {
      subject: `Zainteresowanie otwarciem zapisów na kurs: ${courseCategory}`,
      htmlContent: `Użytkownik o emailu ${email} chce dostać przypomnienie o otwarciu zapisów na kurs ${courseCategory}.`
    }
  }

  return {
    subject: 'Zainteresowanie otwarciem zapisów na kursy.',
    htmlContent: `Użytkownik o emailu ${email} chce dostać przypomnienie o otwarciu zapisów na kursy.`
  }
}
